import { render, staticRenderFns } from "./ModernSelect.vue?vue&type=template&id=2f113e58&scoped=true"
import script from "./ModernSelect.vue?vue&type=script&lang=js"
export * from "./ModernSelect.vue?vue&type=script&lang=js"
import style0 from "./ModernSelect.vue?vue&type=style&index=0&id=2f113e58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/msuarez/PycharmProjects/terrada-front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f113e58",
  null
  
)

export default component.exports